<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<select v-model="selected_user_id" class="tbl_select" style="width:200px;">
					<option :value="null">All GPS Log Collected Users</option>
					<!-- <option v-for="u in users" v-bind:value="u.user_id" v-bind:key="u.user_id" :class="dataExists(u.user_id) ? '' : 'nodata'">{{ u.name }} {{ dataExists(u.user_id) }}<span v-if="!dataExists(u.user_id)"> No Data!!!</span></option> -->
					<option v-for="u in users" v-bind:value="u.user_id" v-bind:key="u.user_id" :class="dataCount(u.user_id) > 0 ? '' : 'nodata'"
						>{{ u.name }}<span v-if="dataCount(u.user_id) > 0"> ({{ validDataCount(u.user_id) }})</span></option
					>
				</select>
				<select v-model="selected_date" class="tbl_select" style="width:140px;" @change="selectDate()">
					<option :value="null">Collected Date</option>
					<!-- <option v-for="u in users" v-bind:value="u.user_id" v-bind:key="u.user_id" :class="dataExists(u.user_id) ? '' : 'nodata'">{{ u.name }} {{ dataExists(u.user_id) }}<span v-if="!dataExists(u.user_id)"> No Data!!!</span></option> -->
					<option v-for="d in gps_date_all" v-bind:value="d.log_date" v-bind:key="d.log_date">{{ d.log_date }}</option>
				</select>
				<CustomDatePicker v-model="gps_date" />
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_small2_tbl">
				<table class="list_tbl">
					<thead>
						<tr>
							<th>User Name</th>
							<th width="15%">User ID</th>
							<th width="20%">Date Time</th>
							<th width="15%">Latitude</th>
							<th width="15%">Longitude</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(log, index) in gps_list" v-bind:key="index" v-bind:class="{ on: index == selectedIndex }" @click="selectRow(log, index)">
							<td class="al_left">{{ log.user_name }}</td>
							<td class="al_left">{{ log.user_id }}</td>
							<td class="al_left">{{ log.log_datetime_str }}</td>
							<td class="al_left">{{ log.lat_str }}</td>
							<td class="al_left">{{ log.lng_str }}</td>
						</tr>
					</tbody>
				</table>
				<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

				<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>
				<div class="view_bottom_bt">
					<a href="javascript:void(0);" type="button" class="search_bt" @click="exportExcel">Excel</a>
				</div>
			</div>

			<div class="right_big2_tbl" style="height:760px;">
				<div ref="google">
					<h4 class="inner_h5">Google Map</h4>
					<GoogleMap v-if="showMap" :initialLocation="selected_log" :viewButton="false" :height="740" :width="getGoogleWidth()" />
				</div>
			</div>
		</div>

		<!-- <div class="view_bottom_bt">
			<a href="javascript:void(0);" type="button" class="search_bt" @click="exportExcel">Excel</a>
		</div> -->
		<!-- 
		<Modal @close="closeModal" v-if="showModal">
			<template slot="title">Location</template>
			<template slot="body">
				<GoogleMap :initialLocation="selected_log" v-on:close="closeModal()" />
			</template>
		</Modal> -->
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectGPSLogList, apiGpsIndex } from '@/api/report/report.js';

import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';

// import Modal from '@/components/common/Modal';
import GoogleMap from '@/components/common/GoogleMap';
//import CodeSelect from '@/components/common/CodeSelect';
//import PartnerSelect from '@/components/common/PartnerSelect';
//import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import { today } from '@/utils/date.js';

//import { exportExcel, objectCopy } from '@/api/util';
import { exportDataExcel, objectCopy } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

//import AC from '@/components/common/AC';

export default {
	data: function() {
		return {
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			selected_user_id: null,
			selected_date: null,
			gps_date: today(),
			users: [],

			gps_list: [],
			gps_list_all: [],
			gps_date_all: [],

			//showModal: false,

			selected_log: {},

			selectedIndex: null,

			showMap: true,

			saveParam: null,

			logged_days: [],
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		// Modal,
		GoogleMap,
	},
	methods: {
		teamOnly() {
			//console.log(this.user.company_id, this.modifiable, this.user.admin);
			if ((this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') && !this.modifiable && !this.user.admin) return true;
			else return false;
		},
		selectDate() {
			if (this.selected_date) {
				this.gps_date = this.selected_date;
				this.search();
			}
		},
		dataCount(user_id) {
			return this.gps_list_all.filter(l => l.user_id == user_id).length;
		},
		validDataCount(user_id) {
			return this.gps_list_all.filter(l => l.user_id == user_id)[0].log_count;
		},
		getGoogleWidth() {
			//if (this.$refs.google) console.log(this.$refs.google.clientWidth);
			if (this.$refs.google) return this.$refs.google.clientWidth;
			//console.log(this.$refs.google.clientWidth);
		},
		selectRow(log, index) {
			if (this.selectedIndex == index) return;

			this.selectedIndex = index;
			this.selected_log = {
				lat: parseFloat(log.lat_str),
				lng: parseFloat(log.lng_str),
			};
		},
		// openModal(log) {
		// 	//console.log(log);
		// 	this.selected_log.lat = parseFloat(log.lat_str);
		// 	this.selected_log.lng = parseFloat(log.lng_str);
		// 	this.showModal = true;
		// },
		// closeModal() {
		// 	this.showModal = false;
		// },
		// async exportExcel() {
		// 	if (!this.saveParam) {
		// 		this.$toast.error('Please search first');
		// 		return false;
		// 	}

		// 	const { data } = await apiSelectSalesGoodsList(this.saveParam);
		// 	for (const item of data.salesGoodsList) {
		// 		item.status_name = this.$options.filters.saleStatusName(item.status_code);
		// 		item.item_name = item.item_name && item.item_name.lastIndexOf('-') >= 0 ? item.item_name.substring(0, item.item_name.lastIndexOf('-')) : item.item_name;
		// 	}

		// 	const reportTemplate = await apiGetReportTemplate('salesGood', reportMrtUrl('salesGood'));
		// 	const report = new Report(reportTemplate, data, 'salesGood');
		// 	exportFile(report, 'excel');
		// },
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectGPSLogList(pageNo);
		},
		reset() {
			// this.sort_key = 'code';
			// this.sort_direction = 'ASC';

			this.gps_date = today();
			this.selectedIndex = null;
			this.selected_user_id = null;

			//this.selectInvoices();
			// this.dept_code = null;
		},
		search() {
			this.selectGPSLogList();
		},
		async exportExcel() {
			const vm = this;
			const { data } = await apiSelectGPSLogList(this.saveParam);
			if (!data.gpsList || data.gpsList.length == 0) {
				this.$toast.error('Nothing to export');
			} else {
				let header = [
					{ key: 'user_name', name: 'User Name', width: 25 },
					{ key: 'user_id', name: 'User ID', width: 10 },
					{ key: 'log_datetime_str', name: 'Date Time', width: 20 },
					{ key: 'lat', name: 'Latitude', width: 15, dataType: defaultDataType.number },
					{ key: 'lng', name: 'Longitude', width: 15, dataType: defaultDataType.number },
				];
				let fileName = 'GPS Log';
				if (vm.saveParam.user_id) fileName = data.gpsList[0].user_name;

				exportDataExcel(data.gpsList, header, fileName);
			}

			// if (!this.saveParam) {
			// 	this.$toast.error('Please search first');
			// 	return false;
			// } else {
			// 	console.log(this.saveParam);
			// }
		},
		async selectGPSLogList(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			//console.log('select invoices');
			//const { data } = await selectAllPensioner();
			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				user_id: this.selected_user_id,
				gps_date: this.gps_date,
			};
			if (this.teamOnly()) param.team_only = true;

			let saveParam = {
				paging_yn: 'N',
				user_id: this.selected_user_id,
				gps_date: this.gps_date,
			};
			if (this.teamOnly()) saveParam.team_only = true;

			this.saveParam = objectCopy(saveParam);

			const { data } = await apiSelectGPSLogList(param);

			//console.log(data);
			// this.gps_list_all = data.gpsList;
			// if (this.selected_user_id) this.gps_list = this.gps_list_all.filter(g => g.user_id == this.selected_user_id);
			// else this.gps_list = this.gps_list_all;
			this.gps_list = data.gpsList;
			this.list_count = data.list_count; //data.list_count;
			this.gps_list_all = data.gpsListAll;
			this.gps_date_all = data.gpsDateAll;
			//console.log(this.gps_date_all);

			//await this.selectAll();

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
		},
		async index() {
			const { data } = await apiGpsIndex();

			if (this.teamOnly()) this.users = data.userList.filter(u => u.sales_team_code == this.user.sales_team_code);
			else this.users = data.userList;

			//console.log(this.user);
		},
		async init() {
			await this.index();

			await this.selectGPSLogList();

			// this.logged_days = [];
			// this.logged_days.push(new Date(2022, 4, 30));
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_gps_log');
		this.$store.commit('setSubTitle', 'Report -> GPS Log');

		this.init();
	},
	mounted() {
		inputSelectOnClick();

		//console.log(this.$refs.google.clientWidth);
	},
};
</script>

<style>
.nodata {
	color: red;
}
</style>
